module.exports = __webpack_public_path__ + "static/media/StepguideSpiderOD.c40dbe97.PNG";